module.exports = __webpack_public_path__ + "39634ca10ef8c196279319cb5f945cd1.svg";